export default function ExchangeLucky({ width = '37', height = '36', color = '#009E93' }) {
  return (
    <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.842 16.833L18.5075 22.5L30.02 10.9875C27.65 7.1025 23.384 4.5 18.5 4.5C11.0435 4.5 5 10.5435 5 18C5 25.4565 11.0435 31.5 18.5 31.5C25.448 31.5 31.1645 26.25 31.9115 19.5" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}
